import { ResetPasswordVerifyOtpNamespace } from '@core/models/client';

export namespace ResetPasswordVerifyOtpApiNamespace {
  export interface IIN {
    recoverPasswordKey: string;
    otp: string;
    recaptchaToken: string;
  }

  export class IN implements IIN {
    recoverPasswordKey: string = '';
    otp: string = '';
    recaptchaToken: string = '';
    constructor(input: ResetPasswordVerifyOtpNamespace.IN) {
      this.recoverPasswordKey = input.requestKey;
      this.otp = input.otp;
      this.recaptchaToken = input.recaptchaToken;
    }
  }

  export class OUT {
    accessToken: string = '';
    expiresIn: number = 0;
  }
}
